import Badge from '@otovo/shared/components/Badge/Badge';
import PortableText from '@otovo/shared/components/Sanity/PortableTextComponents';
import LinkButton from '@otovo/shared/rainbow/LinkButton/LinkButton';
import { Sanity$RowContent } from '@otovo/shared/types/sanityTypes';

type Props = {
  children: Sanity$RowContent[] | string;
};

const HeroLead = ({ children }: Props) => {
  return (
    <div className="space-y-1 text-base text-subheading md:text-xl">
      {typeof children === 'string' ? (
        children
      ) : (
        <PortableText
          value={children}
          components={{
            block: {
              normal: ({ children: textChildren }) => <p>{textChildren}</p>,
            },
            marks: {
              badge: ({ children: content }: { children: React.ReactNode }) => (
                <Badge
                  text={content}
                  className="mr-1 inline px-2.5 py-1 text-sm normal-case"
                />
              ),
              callToActionButton: ({ children: content, value }) => (
                <span className="mt-6 block">
                  <LinkButton href={value.link?.href} rel={value.link?.rel}>
                    {content}
                  </LinkButton>
                </span>
              ),
            },
          }}
        />
      )}
    </div>
  );
};

export default HeroLead;
